import { useState } from 'react';

import buyingOptionsBar from '../../modules/buying-options-bar';

/**
 * Get current buying options.
 *
 * @returns {import('../../modules/buying-options-bar').BuyingOptionsData}
 */
export function useBuyingOptions() {
  const [data] = useState(buyingOptionsBar.getBuyingOptions());
  return data || null;
}
